


















import { Prop, Vue, Component } from 'vue-property-decorator'
import showDiv from '@ivy/fts/showDiv'
@Component
export default class ExchangeCode extends Vue {
  @Prop() code
  @Prop() tips
  message: string =
    '购课成功后，注意领取课程兑换码，将兑换码发送至“画啦啦小灯塔”公众号，即可激活课程。'
  rcode: string = '9345-4567-2344-1234'
  codeObj: any = {}
  async created() {
    this.rcode = this.code
    this.message = this.tips && this.tips.replace(/\n/g, '<br>')
  }
  copy(code) {
    let oInput = document.createElement('input')
    oInput.value = code
    oInput.style.position = 'absolute'
    oInput.style.top = '-999px'
    document.body.appendChild(oInput)
    oInput.select()
    document.execCommand('copy')
    oInput.remove()
    this.$Toast('复制成功 ')
  }
}
